import Reveal from "@/components/Reveal";
import CTABand from "@/components/sections/CTABand";
import EngagementModel from "@/components/sections/EngagementModel";

export default function About() {
  return (
    <div data-testid="page-about">
      {/* Hero */}
      <section className="bg-ink-0 relative overflow-hidden" data-testid="about-hero">
        <div className="absolute inset-0 glow-soft pointer-events-none" aria-hidden="true" />
        <div className="container-edge pt-20 lg:pt-28 pb-20 relative z-10">
          <div className="grid grid-cols-12 gap-8 items-end">
            <Reveal className="col-span-12 lg:col-span-8">
              <div className="eyebrow">About Voice2Evidence</div>
              <h1 className="font-serif font-normal text-4xl md:text-5xl lg:text-[5rem] leading-[1.04] tracking-tight mt-4 text-parchment-bright max-w-4xl">
                Patient voice deserves the rigor required for decision-making.
              </h1>
              <p className="mt-8 max-w-2xl text-parchment/85 text-lg leading-relaxed">
                Voice2Evidence helps pharma teams translate patient voice into evidence-ready strategy across Medical Affairs, HEOR, Market Access, Regulatory Affairs, Commercial, Patient Engagement, and Leadership.
              </p>
              <p className="mt-5 max-w-2xl text-parchment/75 text-lg leading-relaxed">
                It is AI-enabled, expert-validated, evidence-informed, and lifecycle-aware — designed to move patient experience from insight to implication to action.
              </p>
            </Reveal>
            <Reveal
              className="col-span-12 lg:col-span-4"
              delay={120}
              data-testid="about-marksman-card"
            >
              <div className="card-dark p-7">
                <div className="eyebrow-muted mb-2">An initiative by</div>
                <div className="font-serif text-2xl text-parchment-bright">MarksMan Healthcare</div>
                <p className="text-sm text-parchment/70 mt-4 leading-relaxed">
                  Voice2Evidence is built and operated by MarksMan Healthcare — a scientific communications and evidence consultancy with expertise across HEOR, Medical Affairs, real-world evidence, market access, and patient evidence strategy.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <EngagementModel />

      {/* Start with a Scoping Conversation */}
      <section
        className="bg-ink-2 relative border-t border-white/[0.06]"
        data-testid="about-scoping"
      >
        <div className="container-edge py-20 lg:py-24">
          <div className="grid grid-cols-12 gap-x-8 gap-y-8 items-start">
            <Reveal className="col-span-12 lg:col-span-5">
              <div className="eyebrow">Start with a scoping conversation</div>
              <h2 className="font-serif font-normal text-3xl md:text-4xl lg:text-[2.75rem] tracking-tight mt-4 text-parchment-bright leading-[1.05]">
                Confidential. Non-obligatory.
              </h2>
            </Reveal>
            <Reveal className="col-span-12 lg:col-span-7 lg:pt-2" delay={120}>
              <p className="text-parchment/80 text-lg leading-relaxed max-w-xl">
                Scoping conversations are confidential and non-obligatory.
              </p>
              <p className="mt-5 text-parchment/75 text-[15.5px] leading-relaxed max-w-xl">
                Engagements are sized to the asset, lifecycle stage, geography, evidence need, and cross-functional teams involved.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
